/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react'
import PlatformLayout from '../../components/PlatformLayout'
import { Button, Paper, TextField, Typography } from '@mui/material'
import '../../globalStyle.scss'
import { getRules, updateRules } from '../../apiCalls/rulesApi'
import { DataGrid } from '@mui/x-data-grid'
import Switch from '@mui/material/Switch'
import Dialog from '@mui/material/Dialog'
import ReportOutlinedIcon from '@mui/icons-material/ReportOutlined'
import { useNavigate } from 'react-router-dom'
import { useApiGet, useApiPost } from '../../apiCalls/useApi'
import { ConfirmContext } from '../../Confirm'
import { useTranslation } from 'react-i18next'
import { OrgAppContext } from '../../OrgAppContext'
import { getProviderRole } from '../../utils/provider'

type Rule = {
  alertType: string
  appId: string
  appName: string
  id: string
  status: string
  type: string
}

const rulesSort = [
  'AccessSelf',
  'AccessInternal',
  'AccessVIP',
  'AccessRelatives',
  'AccessFamily',
  'AccessNeighbors',
]

export default function RuleSetting() {
  const { customerId, appId } = useContext(OrgAppContext)
  const { t } = useTranslation()
  const providerRole = getProviderRole(customerId)

  const { openConfirm, closeConfirm, setConfirmSettings } = useContext(ConfirmContext)

  const getRuleTitle = (type: string) => {
    return t(`alertType.${type}`, { providerRole })
  }

  const [rules, setRules] = useState([])
  const [isRulesLoading, setIsRulesLoading] = useState<boolean>(false)
  const [chosenRule, setChosenRule] = useState<Rule | null>(null)
  const [chosenType, setChosenType] = useState<string>('')
  const navigate = useNavigate()

  const fetchRules = useApiGet(getRules)
  const updateRuleSetting = useApiPost(updateRules)

  useEffect(() => {
    if (!appId) return
    setIsRulesLoading(true)
    fetchRules({ appId }).then((res: any) => {
      if (res?.data) {
        const data = res.data
        data.sort((a: any, b: any) => {
          return rulesSort.indexOf(a.type) - rulesSort.indexOf(b.type)
        })
        setRules(res.data)
        setIsRulesLoading(false)
      }
    })
  }, [appId])

  const handleSwitch = async () => {
    if (!chosenRule) return
    if (chosenType === 'status') {
      if (chosenRule[chosenType] === 'ON') {
        chosenRule[chosenType] = 'OFF'
      } else {
        chosenRule[chosenType] = 'ON'
      }
    } else if (chosenType === 'alert') {
      if (chosenRule['alertType'] === 'ALERT') {
        chosenRule['alertType'] = 'INDICATOR'
      } else {
        chosenRule['alertType'] = 'ALERT'
      }
    } else {
      return
    }

    const err = await updateRuleSetting({
      appId,
      id: chosenRule.id,
      alertType: chosenRule.alertType,
      status: chosenRule.status,
    })
    if (err) return

    const changedRules: any = rules.map((element: any) => {
      if (element.type === chosenRule.type) return { ...chosenRule }
      return { ...element }
    })
    setRules(changedRules)
    handleClose()
  }

  useEffect(() => {
    const te = chosenRule ? `Switch ${getRuleTitle(chosenRule.type)} 's ${chosenType}?` : ''

    setConfirmSettings({
      text: te,
      confirmCallback: async () => {
        handleSwitch()
      },
    })
  }, [chosenRule])

  const handleChange = (data: any, type: string) => {
    openConfirm()
    setChosenRule(data)
    setChosenType(type)
  }

  const handleClose = () => {
    setChosenRule(null)
    setChosenType('')
    closeConfirm()
  }

  const columns = [
    {
      field: 'type',
      headerName: 'Rules',
      flex: 0.7,
      renderCell: (params: any) => <div>{getRuleTitle(params.value)}</div>,
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 0.6,
      renderCell: (params: any) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography variant='body2' color='textSecondary' style={{ marginRight: 8 }}>
            Off
          </Typography>
          <Switch
            checked={params.value === 'ON'}
            onChange={() => handleChange(params.row, 'status')}
          />
          <Typography variant='body2' color='textSecondary' style={{ marginLeft: 8 }}>
            On
          </Typography>
        </div>
      ),
    },
    {
      field: 'alertType',
      headerName: 'Alert',
      flex: 0.6,
      renderCell: (params: any) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography variant='body2' color='textSecondary' style={{ marginRight: 8 }}>
            Indicator
          </Typography>
          <Switch
            checked={params.value === 'ALERT'}
            onChange={() => handleChange(params.row, 'alert')}
          />
          <Typography variant='body2' color='textSecondary' style={{ marginLeft: 8 }}>
            Alert
          </Typography>
        </div>
      ),
    },
    {
      field: 'setting',
      headerName: 'Setting',
      flex: 0.6,
      renderCell: (params: any) => {
        return (
          <Button
            variant='contained'
            className='ruleSettingDetails'
            onClick={() => {
              navigate(`/detectionRules/${params.row.id}/edit?type=${params.row.type}`)
            }}
          >
            Edit
          </Button>
        )
      },
    },
  ]

  return (
    <Paper square elevation={0} className='paperStyle'>
      <div className='ruleSettingTitle'>
        <div className='ruleSettingTitle'>Detection Rules</div>
        <div className='ruleCount'>{rules.length}</div>
        <div className='ruleTotal'>total</div>
      </div>

      <div className='ruleList'>
        <DataGrid
          loading={isRulesLoading}
          rows={rules}
          hideFooter
          columns={columns}
          sx={{
            border: 0,
            '& .MuiDataGrid-row:hover': {
              backgroundColor: 'rgba(235, 235, 235, 0.7)',
            },
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#FFFFFF',
              color: '#5B5B5B',
              fontSize: '15px',
              fontFamily: 'Segoe UI',
              borderBottom: '2px solid #BABABA',
              // borderRadius: '15px',
            },
            '& .MuiDataGrid-cell': {
              borderBottom: `1px solid #BABABA`,
              color: '#000000',
              fontSize: '12px',
              fontFamily: 'Segoe UI',
              cursor: 'pointer',
              fontWeight: '600',
            },
            '& .MuiDataGrid-columnSeparator': {
              display: 'none',
            },
            '& ::-webkit-scrollbar': {
              width: '5px',
            },
            '& ::-webkit-scrollbar-track': {
              backgroundColor: '#f1f1f1',
            },
            '& ::-webkit-scrollbar-thumb': {
              backgroundColor: '#888',
              borderRadius: '5px',
              '&:hover': {
                backgroundColor: '#555',
              },
            },
            '& .MuiDataGrid-toolbarContainer .MuiButtonBase-root': {
              color: '#5B5B5B',
            },
            '& .MuiDataGrid-toolbarContainer .MuiSvgIcon-root': {
              fill: '#5B5B5B',
            },
          }}
        />
      </div>
    </Paper>
  )
}
